var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"options":_vm.headerOptions}}),_c('Editor',{attrs:{"value":_vm.text},on:{"valChanged":_vm.valChanged,"saveShortcut":_vm.saveNote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }